import coverImage1 from '../../assets/coverImage1.jpg';

export default function ArticlePage(){

    

    return ( 
        

<div>
    
    <img className="fullscreenImage" src= {coverImage1} alt="Cover" />
    <h1>
    
        The 6 Degrees of Separation <br/>
    <div style={{ fontSize: "20px", fontWeight: 'normal' }}>
        
        August 11th, 2025  <br/>
        9:15 pm <br/>
        <div style={{ fontSize: "10px"}}>Written by August</div>
        
    </div>
         </h1> 

         <p className = "postContent">
            
There is a notion that the world is a big place.  <br/> <br/>



If you’ve grown up in the same city, with the same friends, seeing and doing the same things, then the first time you step outside that bubble, you will likely be shocked by how different other people and places are -and consequently, how big the world appears.  <br/>  <br/>



The theory of Six Degrees of Separation tells us that if I take everyone I know, everyone that they know, everyone that THEY know, and repeat this six times, I would somehow have captured the entire world's population -past and present.  <br/>  <br/>



The Six Degrees of Separation argues that the world is small, and that we are all only separated from one another by six other people.  <br/> <br/>



Chances are that if you're reading this then you are a direct friend of mine, or at the very least a mutual. In that case, we are at most one person apart.  <br/> <br/>



But maybe you're a total stranger, maybe you live in Europe, or Australia, or in the US, and our connection isn't yet obvious.  <br/> <br/>



Still, I have friends in all those places, or at least friends who have friends in all those places, so just because you and I don’t know each other, doesn’t mean that me and your bestie don’t.  <br/> <br/>



All of this is to say that both the notion of a big world, and the Six Degrees of Separation are correct. The world is unimaginably large and surprisingly small.  <br/> <br/>


Which leads me to my conclusion on this short thought: We are all closer to one another than we think. What separates you and me from Jordan and Drake is probably not as much as we imagine, and what separates us from the basement sweat shops in certain third-world countries is also... probably not as much as we think.  <br/> <br/>



Therefore, I will very boldly state that if the only thing between me, you, great historical figures of the past, and pop legends of present, is the Six Degrees of Separation, then becoming great is not as far fetched as it seems. <br/> <br/>





“The world was made by people no smarter and no more special than you”

<br/> <br/>


- Steve Jobs

</p>
    
    </div>
    


    );
}